export var OrderShowtimeSeatSwapUnavailableReason;
(function(OrderShowtimeSeatSwapUnavailableReason) {
    OrderShowtimeSeatSwapUnavailableReason[/**
     * Seat swaps are available.
     */ "NotApplicable"] = "NotApplicable";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * Seat swaps have not been enabled for this circuit.
     */ "NotEnabled"] = "NotEnabled";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The [[Showtime]] does not allow allocated seating (see [[Showtime.isAllocatedSeating]]).
     */ "UnallocatedSeating"] = "UnallocatedSeating";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The [[OrderShowtime]] does not include any seats (see [[OrderShowtime.seats]]).
     */ "NoSeats"] = "NoSeats";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The [[OrderShowtime]] includes package tickets (see [[OrderShowtime.tickets]]).
     *
     * @remarks
     * This restriction is due to a current Sales Server limitation and may be resolved in the future.
     */ "PackageTickets"] = "PackageTickets";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The [[StandardOrder]] includes in-seat delivery items for the [[OrderShowtime]] (see [[StandardOrder.items]]).
     *
     * @remarks
     * This restriction is due to a current Sales Server limitation and may be resolved in the future.
     */ "InSeatDeliveryItems"] = "InSeatDeliveryItems";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The order has not been completed.
     *
     * @remarks
     * For [[InProgressStandardOrder]] entities, use the `/ocapi/v1/orders/{orderId}/showtimes/{showtimeId}` method instead.
     */ "OrderNotCompleted"] = "OrderNotCompleted";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The [[StandardOrder]] has been refunded.
     */ "OrderRefunded"] = "OrderRefunded";
    OrderShowtimeSeatSwapUnavailableReason[/**
     * The booking mode of the [[StandardOrder]] is not [[OrderBookingMode.Paid]] (see [[OrderBooking.mode]]).
     */ "UnpaidBooking"] = "UnpaidBooking";
})(OrderShowtimeSeatSwapUnavailableReason || (OrderShowtimeSeatSwapUnavailableReason = {}));

//# sourceMappingURL=order-showtime-seat-swap-unavailable-reason.js.map